import { Avatar, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AboutMail from "../../assets/icons/AboutMailIco";
import ApplicationLogoutIco from "../../assets/icons/ApplicationLogoutIco";
import ChatIco from "../../assets/icons/ChatIco";
import EnterpricePlanIco from "../../assets/icons/EnterpricePlanIco";
import HelpIco from "../../assets/icons/HelpIco";
import LogoutIco from "../../assets/icons/LogoutIco";
import MyProfileIco from "../../assets/icons/MyProfileIco";
import PlanBillingIco from "../../assets/icons/PlanBillingIco";
import SettingIco from "../../assets/icons/SettingsIcon";
import WhatNewIco from "../../assets/icons/WhatNewIco";
import CommonButton from "../../component/Button";
import Setting from "../../layout/PortalLayout/settings";
import { HandleSkeletion } from "../../utils/constants";
import { CustomDiv } from "../chat-bot/style";
import { CommonGrid2 } from "../common-components/StyledComponents";
import DialogCandidateHub from "../jobs/jobs-candidate/components/DialogCandidateHub";
import { CustomizeSpan } from "../jobs/style";
import { MinimizeIcon } from "../../redux/action/Login";
import { useDispatch } from "react-redux";
import { TeamGetCall } from "../../redux/action/UserManagement";
import SnackBar from "../../component/SnackBar";
import { AllPlan } from "../../redux/action/OrganizationSetup";

export default function About() {
  const [loading, setLoading] = useState(true);
  const [defaultSelect, setDefaultSelect] = useState({
    name: "My profile",
    title: "My profile",
    icon: <MyProfileIco />,
    index: 1,
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const navigate = useNavigate();
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [settingDialog, setSettingDialog] = useState({
    dialog: false,
    sidenav: true,
  });
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const theme = useTheme();
  const updatedVersion = process.env.REACT_APP_URL_VERSION;
  const dispatch = useDispatch();
  const aboutData = [
    {
      name: "Enterprise Plan",
      icon: <EnterpricePlanIco />,
      upgrade_button: "Upgrade",
      days: "Days Remaining",
    },
    {
      name: "Help",
      description:
        "If you, send coversheet/interest emails/interview etc to candidate email else primary only.",
      icon: <HelpIco />,
      contact: "Contact Support",
      list: [
        {
          name: "Mail",
          icon: <AboutMail />,
        },
        {
          name: "Chat",
          icon: <ChatIco />,
        },
      ],
    },
    {
      name: "Whats new ?",
      new: "New",
      version: "View new features in",
      icon: <WhatNewIco />,
      view_button: "View",
    },
  ];
  const [planData, setPlanData] = useState({});
  const [logout, setLogout] = useState({
    logoutLoading: false,
    open: false,
    disabled: false,
    noLoading: false,
  });
  const handleSettingToggleDrawer = () => {
    setSettingDialog((prev) => ({
      ...prev,
      sidenav: !prev.sidenav,
    }));
  };

  const handleApplicationLogout = () => {
    setLogout((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleSettingDialogClose = () => {
    setSettingDialog((prev) => ({
      ...prev,
      dialog: false,
    }));
  };

  const FooterLogout = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={logout.disabled}
        loading={logout.noLoading}
        onClick={() => {
          setLogout((prev) => ({
            ...prev,
            disabled: true,
            noLoading: true,
          }));
          setTimeout(() => {
            handleLogout();
          }, 1000);
        }}
      />
      <CommonButton
        value={"Logout"}
        width={"100%"}
        variant="contained"
        color="white"
        background="#D92D20"
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={logout.disabled}
        loading={logout.logoutLoading}
        onClick={() => {
          setLogout((prev) => ({
            ...prev,
            logoutLoading: true,
            disabled: true,
          }));
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            dispatch({ type: "RESET_ALL" });
            navigate("/auth/login");
          }, 1000);
        }}
      />
    </CommonGrid2>
  );

  const handleLogout = () => {
    setLogout({
      noLoading: false,
      open: false,
      logoutLoading: false,
      disabled: false,
    });
  };

  const handleSetting = (condition) => {
    setDefaultSelect(
      condition === true
        ? {
            name: "Plan & Billing",
            title: "Plan & Billing",
            icon: <PlanBillingIco />,
            index: 2,
          }
        : {
            name: "My profile",
            title: "My profile",
            icon: <MyProfileIco />,
            index: 1,
          }
    );
    setSettingDialog((prev) => ({
      ...prev,
      dialog: true,
    }));
  };

  const handleHelp = (name) => {
    if (name === "Chat") {
      dispatch(MinimizeIcon(true, true));
    } else if (name === "Mail") {
      window.location.href = "mailto:help@talairo.com";
    }
  };

  const fetchCall = async () => {
    setLoading(true);
    try {
      let data = await TeamGetCall(true, localStorageData?.user_id);
      const plan = await AllPlan();
      setPlanData((prev) => ({
        ...data?.data,
        username: data?.data?.username || "",
        email: data?.data?.email || "",
        title: data?.data?.title || "",
        ...plan,
      }));
      setLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCall();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  console.log(planData, "sflksnflksfsklmf");

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <CommonGrid2
        container
        alignItems="center"
        spacing={2}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
      >
        <Typography variant="h2">About</Typography>

        <CommonButton
          value={"Logout"}
          startIcon={<ApplicationLogoutIco />}
          color={"#101828"}
          onClick={handleApplicationLogout}
          fontWeight={600}
          fontSize={"16px"}
          padding={"16px"}
          backgroundColor="transparent"
          boxShadow={"none"}
          customStyle={{
            justifyContent: "start",

            "&:hover": {
              boxShadow: "none",
            },
          }}
        />
      </CommonGrid2>

      <CommonGrid2
        size={12}
        display={"flex"}
        gap={"1rem"}
        alignItems={"center"}
        justifyContent={"space-between"}
        border={"1px solid #EAECF0"}
        borderRadius={"10px"}
        padding={"1.5rem 1rem"}
        flexWrap={"wrap"}
        marginTop={"1rem"}
      >
        <CommonGrid2 display={"flex"} gap={"1rem"} alignItems={"center"}>
          {loading ? (
            <HandleSkeletion
              width="50px"
              height="50px"
              // marginRight={"1rem"}
              transform="scale(1)"
              borderRadius="50px"
            />
          ) : (
            <Avatar
              alt="Olivia Rhye"
              sx={{
                width: 70,
                height: 70,
                fontWeight: "700",
                fontSize: "2.5rem",
              }}
            >
              {localStorageData?.username?.charAt(0)?.toUpperCase()}
            </Avatar>
          )}
          <CommonGrid2 display={"flex"} flexDirection={"column"}>
            {loading ? (
              <HandleSkeletion width="80px" height="30px" />
            ) : (
              <Typography
                variant="body5"
                fontWeight={700}
                textTransform="capitalize"
              >
                {localStorageData.username}
              </Typography>
            )}
            {loading ? (
              <HandleSkeletion width="220px" height="40px" />
            ) : (
              <Typography variant="body4" color="#667085" fontWeight={400}>
                {planData.title}
              </Typography>
            )}
            {loading ? (
              <HandleSkeletion width="280px" height="40px" />
            ) : (
              <Typography variant="body4" color="#5A35B2" fontWeight={600}>
                {localStorageData.agency_type}
              </Typography>
            )}
          </CommonGrid2>
        </CommonGrid2>
        {loading ? (
          <HandleSkeletion height={50} width={120} transform={"scale(1)"} />
        ) : (
          <CommonButton
            value={"Settings"}
            startIcon={<SettingIco color={"#5A35B2"} />}
            fontWeight={700}
            gap={"0px"}
            fontSize={"16px"}
            padding={"10px 16px"}
            color="#1A1425"
            backgroundColor="transparent"
            boxShadow={"none"}
            onClick={() => handleSetting(false)}
            customStyle={{
              "&:hover": {
                boxShadow: "none",
              },
            }}
          />
        )}
      </CommonGrid2>
      <CommonGrid2 container spacing={2} size={12} marginTop={"1rem"}>
        {aboutData.map((item, index) => (
          <CommonGrid2
            size={12}
            display={"flex"}
            gap={"10px"}
            alignItems={"center"}
            border={"1px solid #EAECF0"}
            borderRadius={"10px"}
            padding={"1rem"}
          >
            <CommonGrid2
              size={12}
              display={"flex"}
              gap={"1rem"}
              alignItems={"center"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
            >
              <CommonGrid2 display={"flex"} gap={"1rem"} alignItems={"center"}>
                {item.icon}
                {loading ? (
                  <HandleSkeletion
                    height={50}
                    width={200}
                    transform={"scale(1)"}
                  />
                ) : (
                  <CommonGrid2 display={"flex"} flexDirection={"column"}>
                    <Typography variant="body3" fontWeight={700}>
                      {item.days
                        ? planData?.current_plan?.base_name
                        : item.name}
                      {item.new && (
                        <CustomizeSpan
                          padding="3px 5px"
                          background="#D80027"
                          borderRadius="5px"
                          color="#fff"
                          fontSize="11px"
                          margin="0px 0px 0px 10px"
                          customStyle={{
                            display: "inline-block",
                            animation: "pulse 1.2s infinite ease-in-out",
                          }}
                        >
                          New
                        </CustomizeSpan>
                      )}
                    </Typography>
                    {item.days && (
                      <Typography
                        variant="body4"
                        color="#D80027"
                        fontWeight={500}
                      >
                        {planData?.current_plan?.days_left} {item.days}
                      </Typography>
                    )}

                    {item.contact && (
                      <Typography
                        variant="body4"
                        color="#667085"
                        fontWeight={500}
                      >
                        {item.contact}
                      </Typography>
                    )}
                    {item.version && (
                      <Typography
                        variant="body4"
                        color="#667085"
                        fontWeight={500}
                      >
                        {item.version}{" "}
                        <CustomizeSpan color="#7F56D9" fontWeight={700}>
                          {updatedVersion}
                        </CustomizeSpan>
                      </Typography>
                    )}
                  </CommonGrid2>
                )}
              </CommonGrid2>
              {!loading && item.list && (
                <CommonGrid2 container spacing={3} flexWrap={"wrap"}>
                  {item.list.map((list) => (
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      gap={"10px"}
                      cursor="pointer"
                      onClick={() => handleHelp(list.name)}
                    >
                      {list.icon}
                      <Typography variant="body2">{list.name}</Typography>
                    </CommonGrid2>
                  ))}
                </CommonGrid2>
              )}
              {loading ? (
                <HandleSkeletion
                  height={50}
                  width={150}
                  transform={"scale(1)"}
                />
              ) : (
                <Fragment>
                  {item.upgrade_button && (
                    <CommonButton
                      value={item.upgrade_button}
                      fontWeight={600}
                      fontSize={"16px"}
                      onClick={() => handleSetting(true)}
                      padding={"8px 1.5rem"}
                    />
                  )}

                  {item.view_button && (
                    <CommonButton
                      value={item.view_button}
                      color={"#101828"}
                      fontWeight={600}
                      fontSize={"16px"}
                      padding={"8px 1.5rem"}
                      backgroundColor="transparent"
                      boxShadow={"none"}
                      onClick={() => {
                        navigate("/about/what-new");
                      }}
                      customStyle={{
                        justifyContent: "start",
                        "&:hover": {
                          boxShadow: "none",
                        },
                      }}
                    />
                  )}
                </Fragment>
              )}
            </CommonGrid2>
          </CommonGrid2>
        ))}
      </CommonGrid2>

      <Setting
        settingDialog={settingDialog}
        lgUp={lgUp}
        theme={theme}
        handleSettingToggleDrawer={handleSettingToggleDrawer}
        handleApplicationLogout={handleApplicationLogout}
        handleSettingDialogClose={handleSettingDialogClose}
        defaultSelect={defaultSelect}
      />

      <DialogCandidateHub
        open={logout.open}
        centerIcon={<LogoutIco />}
        handleClose={handleLogout}
        footer={<FooterLogout />}
        title="Are you want to logout?"
        titlepadding={"16px 0px 16px"}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
